import React, {useEffect, useState} from "react";
import Pack from "./pack";

const Packs = (props) => {
  const {bundles} = props;
  if (!bundles) return null;

  /* START LINE NORMALIZER CODE */
  /**
   * This bit of code below normalizes div heights among lines to give a "shelf" look
   * and applies the sticky to the header
   */

  var normSets = {
    itemLines: [],
    heightNormalizers: [
      ".pack-header .title-container",
      ".pack-header .price-desc",
      ".pack-offers .offer-desc",
      // ".pack-offers .radio-item label", // é só passar flex no .radio-item
      ".pack-offers",
    ],
  };

  var normalizeLines = function () {
    if (normSets.itemLines) {
      // Clear Heights
      for (var z = 0; z < normSets.itemLines.length; z++) {
        for (var y = 0; y < normSets.itemLines[z].heightMaps.length; y++) {
          for (
            var x = 0;
            x < normSets.itemLines[z].heightMaps[y].items.length;
            x++
          ) {
            normSets.itemLines[z].heightMaps[y].items[x].removeAttribute(
              "style"
            );
          }
        }
      }

      normSets.itemLines = [];
    }

    function heightMap(selector, height) {
      this.selector = selector;
      this.height = height;
      this.items = [];
    }

    function itemLine(offsetTop, items) {
      this.offsetTop = offsetTop;
      this.items = items;
      this.heightMaps = [];
    }

    // Collect Item Lines
    for (var z = 0; z < document.querySelectorAll(".pack-item").length; z++) {
      var item = document.querySelectorAll(".pack-item")[z];

      if (
        !line ||
        item.offsetTop !=
          normSets.itemLines[normSets.itemLines.length - 1].offsetTop
      ) {
        var line = new itemLine(item.offsetTop, [item]);
        normSets.itemLines.push(line);
      } else {
        line.items.push(item);
      }
    }

    for (var x = 0; x < normSets.heightNormalizers.length; x++) {
      // Collect Heights
      for (var z = 0; z < normSets.itemLines.length; z++) {
        var hMap = new heightMap(normSets.heightNormalizers[x], 0);

        //Collect each element for specific height
        for (var y = 0; y < normSets.itemLines[z].items.length; y++) {
          var elements = normSets.itemLines[z].items[y].querySelectorAll(
            normSets.heightNormalizers[x]
          );

          if (elements) {
            for (var i = 0; i < elements.length; i++) {
              var element = elements[i];

              if (element.clientHeight > hMap.height) {
                hMap.height = element.clientHeight;
              }

              hMap.items.push(element);
            }
          }
        }

        normSets.itemLines[z].heightMaps.push(hMap);

        for (var i = 0; i < hMap.items.length; i++) {
          hMap.items[i].style.minHeight = hMap.height + "px";
        }
      }
    }
  };

  var stickySets = {
    curMenuHeight: 0,
    items: () =>
      document.querySelectorAll(".pack-sticky ul.pack-list > li.pack-item"),
    getMenuHeight: function () {
      var header = document.querySelector("header");
      var ctxBar = document.querySelector("header .context-bar");

      if (!header || !header.getAttribute("data-scroll-direction")) {
        return 0;
      } else if (header.getAttribute("data-scroll-direction") == "down") {
        return header.clientHeight;
      } else {
        return header.clientHeight + (ctxBar ? ctxBar.clientHeight : 0);
      }
    },
  };
  var applySticky = function (force) {
    if (
      force === true ||
      stickySets.curMenuHeight != stickySets.getMenuHeight()
    ) {
      stickySets.curMenuHeight = stickySets.getMenuHeight();
      for (var i = 0; i < stickySets.items().length; i++) {
        stickySets.items()[i].querySelector(".pack-header").style.top =
          stickySets.curMenuHeight + "px";
      }
    }
  };
  const [width, setWidth] = useState(window.innerWidth);
  // const [showWeightDetail, setShowWeightDetail] = useState(false);
  useEffect(() => {
    let tout = null;
    const listener = () => {
      clearTimeout(tout);
      tout = setTimeout(() => {
        setWidth(window.innerWidth);
      }, 200);
    };
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [0]);

  useEffect(() => {
    window.addEventListener("resize", normalizeLines);
    window.addEventListener("scroll", applySticky);
    window.addEventListener("resize", applySticky);
    return () => {
      window.removeEventListener("resize", normalizeLines);
      window.removeEventListener("scroll", applySticky);
      window.removeEventListener("resize", applySticky);
    };
  }, [0]);
  useEffect(() => {
    applySticky(true);
    normalizeLines();
  });

  /* END LINE NORMALIZER CODE */

  /**
   * simple comparator function to sort things according to viewport and pack priority
   */
  const comparator = (a, b) =>
    width > 768
      ? -1 * ((a.priority || 0) - (b.priority || 0))
      : -1 *
        ((a.mobilePriority || a.priority || 0) -
          (b.mobilePriority || b.priority || 0));

  // the good stuff is here! renders the <Pack /> component for each bundle provided

  return (
    <React.Fragment>
      <div className="pack-section pack-sticky">
        {/*Caso seja pack-resume, apresenta o título*/}
        {/*Validar qual o tipo de Pacote - processingType - Textos definidos pelo negócio, não é suposto mudar  */}
        {props.resume && bundles[0]?.processingType ? (
          <h4>
            {bundles[0].processingType === "Fixo"
              ? "Resumo do Pacote TV "
              : bundles[0].processingType === "Móvel"
              ? "Resumo do Tarifário M Móvel "
              : ""}
            {bundles[0].title}
          </h4>
        ) : (
          ""
        )}

        <ul className="pack-list" data-items={bundles.length}>
          {bundles.sort(comparator).map((item, idx) => (
            <Pack key={item.id} idx={idx} resume={props.resume} {...item} />
          ))}
        </ul>
      </div>
    </React.Fragment>
  );
};

export default Packs;
